import type * as MediaBunnyType from 'mediabunny'

export const getMediaBunny = async () => {
  const mediaBunnyPath =
    window.MEDIA_BUNNY_JS ||
    'https://cdn.renderforest.com/mediabunny/1.15.2/mediabunny.min.mjs'
  const MediaBunny = (await import(mediaBunnyPath)) as typeof MediaBunnyType
  return MediaBunny
}
